import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  isUnarchive: boolean;
}

export const useArchiveBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, isUnarchive = false }: HookProps) => {
      await request({
        path: `batches/${batchId}/${isUnarchive ? 'un-' : ''}archive`,
        method: 'PUT',
        authenticate: true,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Successfully archived the batch!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error archiving the batch!');
    },
  });
};
